export default "__VITE_ASSET__D30s06Gn__"